import { Routes } from '@angular/router';
import { ShellComponent } from './core/layout/shell.component';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/auth/login.component').then((m) => m.LoginComponent),
  },
  {
    path: '',
    component: ShellComponent,
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
      },
      {
        path: 'orders/add',
        loadComponent: () => import('./features/add-order/add-order.component').then((m) => m.AddOrderComponent),
      },
      {
        path: 'orders/pending',
        loadComponent: () =>
          import('./features/pending-orders/pending-orders.component').then((m) => m.PendingOrdersComponent),
      },
      {
        path: 'orders/history',
        loadComponent: () =>
          import('./features/order-history/order-history.component').then((m) => m.OrderHistoryComponent),
      },
      {
        path: 'orders/quotations',
        loadComponent: () =>
          import('./features/quotations/quotations.component').then((m) => m.QuotationsComponent),
      },
      {
        path: 'orders/:orderId/invoice',
        loadComponent: () =>
          import('./features/generate-bill/generate-bill.component').then((m) => m.GenerateBillComponent),
      },
      {
        path: 'settings/categories',
        loadComponent: () => import('./features/categories/categories.component').then((m) => m.CategoriesComponent),
      },
      {
        path: 'settings/products',
        loadComponent: () => import('./features/products/products.component').then((m) => m.ProductsComponent),
      },
      {
        path: 'settings/invoice',
        loadComponent: () =>
          import('./features/invoice-settings/invoice-settings.component').then((m) => m.InvoiceSettingsComponent),
      },
      {
        path: 'reports/account-statement',
        loadComponent: () =>
          import('./features/account-statement/account-statement.component').then((m) => m.AccountStatementComponent),
      },
      {
        path: 'reports/account-summary',
        loadComponent: () =>
          import('./features/reports/account-summary.component').then((m) => m.AccountSummaryComponent),
      },
      {
        path: 'reports/sales',
        loadComponent: () => import('./features/reports/sales-report.component').then((m) => m.SalesReportComponent),
      },
      {
        path: 'reports/dues',
        loadComponent: () => import('./features/reports/dues-report.component').then((m) => m.DuesReportComponent),
      },
      {
        path: 'reports/cash-collection',
        loadComponent: () =>
          import('./features/reports/cash-collection-report.component').then((m) => m.CashCollectionReportComponent),
      },
      // Catch-all INSIDE the shell so an unknown path keeps the nav chrome and the user
      // can navigate onwards, rather than dropping them on a bare page.
      {
        path: '**',
        loadComponent: () => import('./features/not-found/not-found.component').then((m) => m.NotFoundComponent),
      },
    ],
  },
  // Catch-all for unauthenticated users, who never reach the guarded shell above.
  { path: '**', redirectTo: '' },
];
